import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { wizardTrackingIds } from 'client/tracking/maps/incentives-wizard';
import { SrpTopIncentivesContext } from 'site-modules/shared/components/inventory/incentives-wizard/srp-top-incentives/srp-top-incentives-context-provider';
import { LoadingDots } from 'site-modules/shared/components/loading-dots/loading-dots';
import { Link } from 'site-modules/shared/components/link/link';
import { Button } from 'reactstrap';

export function SrpTopIncentivesButton({ isMobile, onClick }) {
  const { buttonText, href } = useContext(SrpTopIncentivesContext);

  const handleClick = useCallback(() => {
    if (href) return;
    onClick();
  }, [href, onClick]);

  return (
    <Button
      tag={href ? Link : 'button'}
      href={href}
      onClick={handleClick}
      size="sm"
      color="blue-50"
      className={classnames('pos-r text-capitalize fw-medium size-16 px-1 py-0_5 rounded-8 z-index-1', {
        'mt-1 w-100': isMobile,
      })}
      style={{ minWidth: '178px', height: '40px' }}
      data-tracking-id={wizardTrackingIds.openIncentivesMatcher}
      data-tracking-value={buttonText}
    >
      <>
        <LoadingDots
          dotClassName="bg-white"
          style={{
            position: 'absolute',
            visibility: !buttonText ? 'visible' : 'hidden',
            transform: 'translate(-50%, -50%)',
            top: '50%',
            left: '50%',
          }}
        />
        <span style={{ visibility: buttonText ? 'visible' : 'hidden' }}>{buttonText}</span>
      </>
    </Button>
  );
}

SrpTopIncentivesButton.propTypes = {
  isMobile: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SrpTopIncentivesButton.defaultProps = {
  isMobile: false,
};
